import React from 'react';
import { Section, CTAButton } from './Shared';
import { CheckCircle2 } from 'lucide-react';
export const Hero = () => {
  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <Section className="pt-12 md:pt-20 pb-16" data-id="element-207">
      <div className="text-center max-w-4xl mx-auto" data-id="element-208">
        <h1 className="font-montserrat font-black text-4xl md:text-5xl lg:text-6xl uppercase leading-tight md:leading-tight text-black mb-8" data-id="element-209">
          Creá contenido sin bloquearte y empezá a ser constante en redes en
          solo{' '}
          <span className="text-coral underline decoration-gold decoration-4 underline-offset-8" data-id="element-210">
            30 días
          </span>
        </h1>

        <div className="flex justify-center mb-8 cursor-pointer hover:scale-[1.02] transition-transform" onClick={scrollToOffer} data-id="element-211">
          <img src="https://cdn.magicpatterns.com/uploads/sv8DHjWWdQRJhD1Fvq2Rjv/De_0_a_influencer.png" alt="De 0 a Influencer" className="w-full max-w-[400px] drop-shadow-2xl" data-id="element-212" />
        </div>

        <h2 className="font-opensans text-xl md:text-2xl font-semibold text-gray-800 mb-10 leading-relaxed" data-id="element-213">
          Un sistema simple con ideas listas, planificación clara y pasos
          accionables para que dejes de pensar tanto y empieces a publicar en
          Instagram y TikTok
        </h2>

        <div className="bg-gray-50 p-6 md:p-8 rounded-2xl border border-gray-100 mb-10 text-left max-w-2xl mx-auto shadow-sm" data-id="element-214">
          <ul className="space-y-4" data-id="element-215">
            {['Nunca más quedarte sin ideas', 'Saber exactamente qué publicar cada semana', 'Crear contenido sin miedo ni perfeccionismo', 'Desarrollar constancia real, no motivación momentánea'].map((bullet, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-216">
                <CheckCircle2 className="w-6 h-6 text-coral shrink-0 mt-0.5" data-id="element-217" />
                <span className="font-opensans text-lg font-medium text-gray-800" data-id="element-218">
                  {bullet}
                </span>
              </li>)}
          </ul>
        </div>

        <CTAButton text="Quiero empezar ahora" subtext="Acceso inmediato. Sin experiencia previa." data-id="element-219" />
      </div>
    </Section>;
};